module.exports = import("https://cdn.skypack.dev/three@0.129.0/examples/jsm/loaders/GLTFLoader.js");;